import { useDispatch as useReduxDispatch } from 'react-redux';
import { AnyAction } from '@reduxjs/toolkit';
import { Dispatch } from 'react';
import { ThunkAppDispatch } from '../types/redux/utils/ThunkAppDispatch';

export const useDispatch: () => ThunkAppDispatch & Dispatch<AnyAction> = useReduxDispatch;
